import api from '@/interface/baseApi'

//生成H5支付订单
export function createPayH5(params) {
	return api({
		url: '/paycenter/paycenter/createPayH5',
		method: 'post',
		data:{
			uuid: params.uuid,
			orderId: params.orderId,
			payId: params.payId,
			terminal: params.terminal,
		}
	})
}